export default {"src":"/_next/static/media/sign-up-question-logo.377a8021.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};